import React from "react";
import image1 from "../../../Assets/Compliance Certifictes/image.png";
import image2 from "../../../Assets/Compliance Certifictes/image2.png";

const IATFInfoContainer = () => {
  return (
    <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
      {/* left side */}
      <div className="w-full">
        {/* heading */}
        <div className="py-4 md:py-10">
          <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
            <h1 className="">
              <span className="border-b-4 border-[#249742]">IATF</span> GMP
              16949:2016
            </h1>
          </div>
        </div>

        {/* content */}
        <div>
          <p className="font-normal text-lg text-[#4D4D4D] ">
            Quality management systems — Particular requirements for the
            application of ISO 9001:2008 for automotive production and relevant
            service part organizations
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            IATF 16949:2016, in conjunction with ISO 9001:2008, defines the
            quality management system requirements for the design and
            development, production and, when relevant, installation and service
            of automotive-related products.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            IATF 16949:2016 is applicable to sites of the organization where
            customer-specified parts, for production and/or service, are
            manufactured.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            Supporting functions, whether on-site or remote (such as design
            centres, corporate headquarters and distribution centres), form part
            of the site audit as they support the site, but cannot obtain
            stand-alone certification to IATF 16949:2016.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            IATF 16949:2016 can be applied throughout the automotive supply
            chain.
          </p>
        </div>
      </div>

      {/* right side */}
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="py-0 sm:py-8">
          <img
            src={image2}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>

        <div className="py-0 sm:py-8">
          <img
            src={image1}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default IATFInfoContainer;
